import React from "react";
import { NavLink } from "react-router-dom";
import strings from "../Language";
import { images } from "../../config/image";

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: strings.getLanguage(),
        }
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <>
                <nav className="bottom-nav">
                    <NavLink to={"/"} className="nav-item">
                        <img className="home-icon" src={images['home-icon']} alt="" />
                        <span id="navHome">{strings["navHome"]}</span>
                    </NavLink>
                    <NavLink to={"/location"} className="nav-item">
                        <img className="location-icon" src={images['location-icon']} alt="" />
                        <span id="navLocation">{strings["navLocation"]}</span>
                    </NavLink>
                    <NavLink to={"/profile"} className="nav-item">
                        <img className="profile-icon" src={images['profile-icon']} alt="" />
                        <span id="navProfile">{strings["navProfile"]}</span>
                    </NavLink>
                    <NavLink to={"/installer"} className="nav-item">
                        <img className="installer-icon" src={images['installer-icon']} alt="" />
                        <span id="navInstaller">{strings["navInstaller"]}</span>
                    </NavLink>
                    <NavLink to={"/about-menu"} className="nav-item">
                        <img className="about-icon" src={images['about-icon']} alt="" />
                        <span id="navAbout">{strings["navAbout"]}</span>
                    </NavLink>
                </nav>
            </>
        );
    }
}

export default Footer;